import React, { useState, useEffect,useRef } from "react";
import ReactPaginate from "react-paginate";
import axios from 'axios';
import { getUserId,aPIURL,auTHURL,getLoginName,websiteUrl } from '../utils/common';
import Modal from  './Modal';
import ModalSale from './ModalSale';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useReactToPrint } from 'react-to-print';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import Ctus from './ShowMap';
import Locations from '../components/ClientApplication/CVLocations'
import HistoryonMap from "../components/ClientApplication/HistoryonMap";
import HistoryPlayback from "../components/ClientApplication/HistoryPlayback"

const AdminVehicleList = () => {

  const fileType ="xlsx";
  const tableRef = useRef(null);
  const API_URL=aPIURL();
  const [userId, setUserId]  = useState({});
  const [userName, setUserName]  = useState({});
  const [inputsEdit, setInputsEdit] = useState({});
  const [post, setPost] = useState([]);
  const [vCategoryData, setVCategoryData]= useState([]);
  const [vCountryData, setVCountryData]= useState([]);
  const [vStateData, setVStateData]= useState([]);
  const [vIEMIData, setVIEMIData]= useState([]);
  const [vDriverData, setVDriverData]= useState([]);
  const [number, setNumber] = useState(1); 
  const [postPerPage] = useState(10);
  const [viewVehicle, setViewVehicle]= useState(false);
  const [showEditVehicle, setShowEditVehicle]= useState(false);
  const [sVehicleNo , setSVehicleNo]= useState();                    
  const [sPlateNo , setSPlateNo]= useState();                              
  const [sVehicleType, setSVehicleType]= useState();                             
  const [sVIN, setSVIN]= useState();   
  const [sMake , setSMake]= useState();                        
  const [sModel  , setSModel]= useState();                          
  const [sYear  , setSYear]= useState();                          
  const [sEngineNo, setSEngineNo]= useState();                           
  const [sIMEINo, setSIMEINo]= useState();  
  const [sFASTag, setSFASTag]= useState(); 
  const [sMileage, setSMileage] = useState("0");
  const [sCountry, setSCountry]= useState();  
  const [sState, setSState]= useState();   
  const [sDriverName, setSDriverName]= useState(); 
  const [sContactNumber, setSContactNumber]= useState(); 
  const [sAddress, setSAddress]= useState();     
  const [veCategoryID, setVeCategoryID]= useState(0);
  const [veCountryID, setVeCountryID]= useState(0);
  const [veStateID, setVeStateID]= useState(0);
  const [veIEMINumber, setVeIEMINumber]=useState(0);
  const [vEDriverID, setVEDriverID]=useState(0);
  const [order, setOrder] = useState("ASC");
  const [statusId, setStatusId]= useState(0);  
  const [sVehicle,setSVehicle]=useState("");
  const [ssmodel,setSSModel]=useState("");
  const [sdriver,setSdriver]=useState("");
  const [showLocation,setShowLocation ]  = useState(false);
  const [dID, setDID]  = useState('0');
  const [showViewLiveVehicle, setShowViewLiveVehicle]= useState(false);
  const rc =0;
  let [strLiveUrl,setStrLiveUrl]=  useState("");
  const [imeiNo,setImeiNo]= useState(0);
  
  //For history on map serach
  const [showHistoryDetails,setShowHistoryDetails]= useState(false);
  const [showHistoryPlayback,setShowHistoryPlayback]= useState(false);
  const [himei,setHimei]=useState();
  const [hfromdt,setHfromdate]=useState();
  const [htodate,setHtodate]=useState();
  const historyonmapinfo={IMEI:himei,fromDate:hfromdt,toDate:htodate}  
  const [historyData, setHistoryData] = useState([]);

  var fday = new Date();
  var fdd = fday.getDate();
  var fmm = fday.getMonth() + 1; //January is 0 so need to add 1 to make it 1!
  var fyyyy = fday.getFullYear();
  if (fdd < 10){fdd = '0' + fdd}
  if (fmm < 10){fmm = '0' + fmm}
  fday = fyyyy + '-' + fmm + '-' + fdd;
    
  const [frFilterDate, setFrFilterDate]= useState(fday); 
  const [toFilterDate, setToFilterDate]= useState(fday); 
  const [vehicleNo,setVehicleNo]=useState('0');
  const [isShowMap, setIShowMap] = useState(false);
  const lastPost = number * postPerPage;
  const firstPost = lastPost - postPerPage;
  const currentPost = post.slice(firstPost, lastPost);
  const PageCount = Math.ceil(post.length / postPerPage);
  

  useEffect(() =>  {  FillGrid(0,"0","0","0");   }, []);
      
 const FillGrid=(Type_ID,Vehicle_Number,Vehicle_Model,Driver_Name)=>
 {
   
    const user_id = getUserId(); 
    setUserId(user_id);
    const User_Name=getLoginName();
    setUserName(User_Name);
    const curls=API_URL+`AdminVehicleList/?TypeID=${Type_ID}&VehicleNumber=${Vehicle_Number}&VehicleModel=${Vehicle_Model}&DriverName=${Driver_Name}`;
    //alert(curls);
    setPost([]);
  
    axios.get(curls).then(response => 
    {                            
      setPost(response.data.data)
      console.log("-------------------Vehicle List-----------------------");
      console.log(response.data.data); 

    }).catch(function(error){
    console.log(error.message);});      
 }

const FilterGrid=()=>
{
     
     FillGrid(statusId,sVehicle,ssmodel,sdriver);

}

const ResetList=()=>
{
      setSVehicle("");
      setSSModel("");
      setSdriver("");
      FillGrid(0,"0","0","0");
}

const VchangeHandler=(e)=>
{
      setSVehicle(e.target.value)
}
const MchangeHandler=(e)=>
{
      setSSModel(e.target.value)
}
const DchangeHandler=(e)=>
{
      setSdriver(e.target.value)
}

const ChangePage = ({ selected }) => {
        
      setNumber(selected+1);
};

const sorting=(col)=>
{

    try
    {
      if(order==="ASC")
      {
              const sorted=[...post].sort((a,b)=>
              a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1
              );
              setPost(sorted);
              setOrder("DSC");
      }
      if(order==="DSC")
      {
              const sorted=[...post].sort((a,b)=>
              a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1
              );
              setPost(sorted);
              setOrder("ASC");
      }
    }
    catch(error) 
    {
      console.log(error.message);
    }  
            
}
const exportStatus = e => {
    
    const value = e.target.value; 
    setStatusId(e.target.value);
    FillGrid(value,sVehicle,ssmodel,sdriver)
}
const exportToCSV=()=>
{
      const newPost = post.map(({ address,contactNumber,countryId,countryName,deviceID,driverID,expiryDate,fasTag,imgPath,regYear,stateID,stateName,vehicleID,vehicleTypeID,vin,accountID, ...rest }) => rest);
       const ws= XLSX.utils.json_to_sheet(newPost);        
       var wscols = [
          {wch:5} ,
          {wch:20},
          {wch:20},
          {wch:20},
          {wch:20},
          {wch:20},
          {wch:20},         
          {wch:20},
          {wch:20},         
          {wch:20}
      ];
   
      var wsrows = [
         {hpx: 30}
      ];
      
      ws['!cols'] = wscols;
      ws['!rows']=wsrows;
           
      let Heading = [['S.No.','Vehicle Number','Plate Number','Vehicle Type','Make','Vehicle Model','Engine Number','IMEI Number','Driver Name','Status']];
      const wb={Sheets:{Vehicle:ws},SheetNames:["Vehicle"]};
      XLSX.utils.sheet_add_aoa(ws, Heading);     
      const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
      const data= new Blob([excelBuffer],{type:fileType});
      FileSaver.saveAs(data,"AvtVehicleReport"+".xlsx");
     
  
}
const exportDownload = e => 
{  
   const value = e.target.value; 
  
if(value==="Excel")
{
    exportToCSV();    
}
if(value==="PDF")
{
        handlePrint(null, () => tableRef.current);
}
}

const handlePrint = useReactToPrint({
  documentTitle: "Vehicle Details",
  onBeforePrint: () => console.log("before printing..."),
  onAfterPrint: () => console.log("after printing..."),
  removeAfterPrint: true,
});



const closeVehicleModal = () => {

    setShowEditVehicle(false);
    setViewVehicle(false);
    setShowViewLiveVehicle(false);
    setShowHistoryDetails(false);
    setShowHistoryPlayback(false);
    FillGrid(0,"0","0","0"); 
         
} 
const closeModal = () => 
  {
        setShowEditVehicle(false);
        setViewVehicle(false);
        setShowLocation(false); 
        setShowViewLiveVehicle(false);
        setShowHistoryDetails(false);
        setShowHistoryPlayback(false);
         
  } 
  const closeHistoryModal=()=>
  {
        setShowEditVehicle(false);
        setViewVehicle(false);
        setShowLocation(false); 
        setShowViewLiveVehicle(false);
        setShowHistoryDetails(false);
        setShowHistoryPlayback(false);
  }
 const closeHistoryPlaybackModal=()=>
 {
        setShowEditVehicle(false);
        setViewVehicle(false);
        setShowLocation(false); 
        setShowViewLiveVehicle(false);
        setShowHistoryDetails(false);
        setShowHistoryPlayback(false);

 }

const changeVEHandler = (event) => {
  if(event.target.name==='vYear')
  {
        const re = /^[0-9\b]+$/;
        if (event.target.value === '' || re.test(event.target.value)) 
        {
         
            const name = event.target.name;
            const value = event.target.value;
            setInputsEdit(values => ({...values, [name]: value}))
        }
        else
        {
              setInputsEdit(values => ({...values, ['vYear']: ""}))
              
        }
        
  }
  else if(event.target.name==='vMileage')
    {
          const re = /^[0-9\b]+$/;
          if (event.target.value === '' || re.test(event.target.value)) 
          {
               const name = event.target.name;               
               const value = event.target.value;
               setInputsEdit(values => ({...values, [name]: value}))
          }
          else
          {
            setInputsEdit(values => ({...values, ['vMileage']: ""}))                
          }          
    }
  
  else
  {
      const name = event.target.name;
      const value = event.target.value;
      setInputsEdit(values => ({...values, [name]: value}))
  }
  }

const vehicleEdit=()=> {
    
    //console.log(inputsEdit);
   if((!inputsEdit.vehicleNumber) || inputsEdit.vehicleNumber==='')
    {
        toast.error("Vehicle number is required.");
        return;
    }
    else if(veCategoryID ===0)
    {
        toast.error("Vehicle type is required.");
       return;
    }    
    else if(veIEMINumber===0 || veIEMINumber==='0') 
    {
        toast.error("Device IMEI number is Required.");
         return;
    }
    else if(veCountryID===0)
    {
        toast.error("Country is required.");
       return;
    }
    else if(veStateID==="0")
    {
        toast.error("State is required.");
       return;
    }    
    else
    {
     
           //Edit vehicle Details
           const vparams = JSON.stringify({
            "vehicleId": inputsEdit.vehicleId,
            "accountID": userId,            
            "imeiNumber": veIEMINumber,
            "driverID": vEDriverID,
            "vehicleNumber": inputsEdit.vehicleNumber,
            "enginNumber": inputsEdit.vEnginNumber,
            "vehicleBrand": inputsEdit.vBrand,
            "plateNumber": inputsEdit.plateNumber,
            "vehicleModel": inputsEdit.vModel,
            "vin": inputsEdit.vVin,
            "vehicleTypeID": veCategoryID,
            "regYear": inputsEdit.vYear,
            "imgPath": "",
            "fastTag": inputsEdit.vFasTag,
            "countryID": veCountryID,
            "stateID": veStateID,
             "mileage" : inputsEdit.vMileage    
        });
       
        //alert(vparams);
       axios.post(API_URL+'NewInsertVehicle/', vparams, {
    
             "headers": 
             {
                    "content-type": "application/json",    
             },
    
        })
          .then(function (response) 
          {
                                 
            if(response.data.validStatus === false)
            {
                toast.error(response.data.message); 
            }
            else
            {
                toast.success(response.data.message); 
                FillGrid(0,"0","0","0");
                          
           }
          }).catch(function(error){console.log(error.message);});
                      
      
        }
          
}
const showDetailsModal = (index) => {
     
    const vurls=API_URL+`VehicleListbyId/${index}`;
   
    axios.get(vurls).then(response => {    
                    
                    setSVehicleNo(response.data.data[0].vehicleNumber);                    
                    setSPlateNo(response.data.data[0].plateNumber);                             
                    setSVehicleType(response.data.data[0].vehicleType);                             
                    setSVIN(response.data.data[0].vin);   
                    setSMake(response.data.data[0].vehicleBrand);                        
                    setSModel(response.data.data[0].vehicleModel);                         
                    setSYear(response.data.data[0].regYear);                          
                    setSEngineNo(response.data.data[0].enginNumber);                           
                    setSIMEINo(response.data.data[0].imeiNumber); 
                    setSFASTag(response.data.data[0].fasTag);  
                    setSMileage(response.data.data[0].mileage);
                    setSCountry(response.data.data[0].countryName);  
                    setSState(response.data.data[0].stateName);
                    setSDriverName(response.data.data[0].driverName);
                    setSContactNumber(response.data.data[0].contactNumber);
                    setSAddress(response.data.data[0].address);                                       
                    
            }).catch(function(error){console.log(error.message);});    
       
    setViewVehicle(true);
    
}
const showEditVehicleDetails=(index) => {

    const catUrl=API_URL+"VehicleType/2";
    axios.get(catUrl).then(response => {
        setVCategoryData(response.data.data);
    }).catch(function(error){console.log(error.message);}); 
    
    axios.post(API_URL+'countries').then(response => {
           setVCountryData(response.data.data);        
        }).catch(function(error){console.log(error.message);});
        
    axios.post(API_URL+'states?Country_ID=1').then(response => {
           setVStateData(response.data.data);  
        }).catch(function(error){console.log(error.message);});
    
     const ADriveUrl=API_URL+`PendingDriverList?StatusID=0&AccountID=${userId}`;
     setVDriverData([]);
      axios.get(ADriveUrl).then(response => 
      {

        if(response.data.validStatus)
        {
            
          setVDriverData(response.data.data);  
       
        }
      }).catch(function(error){console.log(error.message);});

      const IEMIUrl=API_URL+`ImeipendingList/{id}?StatusID=0&AccountID=${userId}`;
      setVIEMIData([]);
      axios.get(IEMIUrl).then(response => 
      {
        setVIEMIData(response.data.data); 
      
      }).catch(function(error){console.log(error.message);});

      
    const vurls=API_URL+`VehicleListbyId/${index}`;
    
    inputsEdit.vehicleId= index;
    axios.get(vurls).then(response => {               
                    //console.log("---------------------Check----------------------");
                    //console.log(response.data.data);
                    inputsEdit.vehicleNumber = response.data.data[0].vehicleNumber;                    
                    inputsEdit.plateNumber = response.data.data[0].plateNumber;         
                    inputsEdit.vVin = response.data.data[0].vin;   
                    inputsEdit.vBrand = response.data.data[0].vehicleBrand;                        
                    inputsEdit.vModel = response.data.data[0].vehicleModel;                         
                    inputsEdit.vYear = response.data.data[0].regYear;                          
                    inputsEdit.vEnginNumber = response.data.data[0].enginNumber;    
                    setVEDriverID(response.data.data[0].driverID==null?0:response.data.data[0].driverID);                 
                    setVeIEMINumber(response.data.data[0].imeiNumber==null?"0":response.data.data[0].imeiNumber); 
                    inputsEdit.vFasTag = response.data.data[0].fasTag;  
                    setVeCategoryID(response.data.data[0].vehicleTypeID);
                    setVeCountryID(response.data.data[0].countryId);
                    setVeStateID(response.data.data[0].stateID);  
                    inputsEdit.vMileage = response.data.data[0].mileage; 
                                       
            }).catch(function(error){console.log(error.message);});    
       
    setShowEditVehicle(true);
}  

const showLocationDetailsModal = (index) => 
{
    const d_Id = index;    
    setDID(d_Id); 
    setShowLocation(true); 
    setShowEditVehicle(false);
    setViewVehicle(false);     
}

const showLiveVehiclesModal = (index) => {
     
   let WEB_URL=websiteUrl();  
  setShowViewLiveVehicle(true);
  let strUrl=WEB_URL+"Live.html?ID=" + index;
  setStrLiveUrl(strUrl);
  

}
const showHistoryVehiclesModal = (par1,par2) => {
     
    setShowHistoryDetails(true);    
    setVehicleNo(par2);
    setImeiNo(par1);    
    setHimei(par1);
    setHfromdate(today);
    setHtodate(today);  
     //let strUrl= "https://login3.avtbharat.com/Live.html?ID=" + index;
     //setStrLiveUrl(strUrl);
  

}
const showHistoryPlaybackModal= (par1,par2) => {
     
      setShowHistoryPlayback(true);    
      setVehicleNo(par2);
      setImeiNo(par1);    
      setHimei(par1);
      setHfromdate(today);
      setHtodate(today); 

}
const  shareLocationClick = (IMEI_No) => 
{
    const WEB_URL=process.env.REACT_APP_WEB;//    wEBURL();     
    setImeiNo(IMEI_No);
    const daurls=API_URL+`Externaltoken/${IMEI_No}/24`; 
    const response =  axios.post(daurls).then(response => 
     {
        const copyurls=WEB_URL+`Monitor.html?token=${response.data.data[0].token}`;  
        
        navigator.clipboard.writeText(copyurls)
        .then(() => {
          alert("successfully copied,Please share url for 24 hours");
        })
        .catch(() => {
          alert("something went wrong");
        });
    
      }).catch(function(error) 
     {
       console.log(error.message);
     });  
    /* */
}

const ActionCommandONOFF=(vIMEINO)=>

  {
    if(window.confirm('Do you want to ON/OFF the vehicle?'))
    {
      const params = JSON.stringify({"IMEINumber": vIMEINO,"Command": '',"User":userName});
      axios.post(API_URL+'ActionCommand/', params, 
      {
           "headers": 
           {
                  "content-type": "application/json",    
           },
      })
        .then(function (response) 
        {
          
            if(!response.data.data[0].status)
             {
                   toast.error(response.data.data[0].message);
                   return;
             }
             else
             {   
                   FillGrid(0); 
                   toast.success(response.data.data[0].message);             
              
             }              

        }).catch(function (error) 
        {
                toast.error(error.message);
                console.log(error);    

        });
      } 
      else 
      {
              toast.error('Action operation canceled.');
      }

  }
const ChangeVCategoryIDD = (e) => {

    setVeCategoryID(e.target.value);       
}
const ChangeCountryID = (e) => {

    setVeCountryID(e.target.value);   
}
const ChangeIMEI = (e) => {

  setVeIEMINumber(e.target.value); 
}
const ChangeEDriver = (e) => {

  setVEDriverID(e.target.value); 
}
const ChangeStateID = (e) => {

  setVeStateID(e.target.value); 
}
const DeleteVehicleDetails=(index)=>{

  if(window.confirm('Do you want to disable the vehicle?'))
  {
        const ddurls=API_URL+`Vehicle_Delete?AccountID=${userId}&Vehicle_ID=${index}`;
        axios.post(ddurls).then(response => {
        if(response.data.validStatus === false)
           {
                toast.error(response.data.message); 
           }
           else
           {
                 FillGrid(0,"0","0","0");
           }        
  }).catch(function(error) 
  {
    console.log(error.message);
  }); 
} 
else 
{
    toast.error('Disable operation canceled.');
}
}
 const ShowTodayData=()=>
   {  
     setFrFilterDate(today);
     setToFilterDate(today);
     setHfromdate(today);
     setHtodate(today);   
    
   }
   const ShowWeeklyData=()=>
   {
     
      var Startdt=getMonday(new Date());
      setHimei(imeiNo);
      setFrFilterDate(Startdt);
      setToFilterDate(today);
      setHfromdate(Startdt);    
      setHtodate(today); 
      
   }
   const ShowMonthlyData=()=>
   {
      
      var DateFirstdayofMonth = new Date();
      var firstDay = new Date(DateFirstdayofMonth.getFullYear(), DateFirstdayofMonth.getMonth(), 1).toLocaleDateString('en-CA');
      setFrFilterDate(firstDay);
      setToFilterDate(today);
      setHimei(imeiNo);
      setHfromdate(firstDay);
      setHtodate(today);
 
      
   }
    
    const ShowSearchData=()=>
    {
      if(frFilterDate> toFilterDate)
       {
         toast.error("From date should be less than to date.");
         return;
       }
       else
       {
           setHimei(imeiNo);
           setHfromdate(frFilterDate);
           setHtodate(toFilterDate);
       }
    }
    const dfrChangeHandler= (e) => 
      {
            setFrFilterDate(e.target.value); 
            setHistoryData([]);                  
      }
      const dtoChangeHandler= (e) => 
      {
            setToFilterDate(e.target.value); 
           setHistoryData([]);           
      }

   //mindate date range start
   let minDatefr = new Date()
   minDatefr.setDate(minDatefr.getDate() - 30)
   //alert(minDatefr);
   var ddfr = minDatefr.getDate();
   var mmfr = minDatefr.getMonth() + 1; 
   var yyyyfr = minDatefr.getFullYear();

   if (ddfr < 10) {ddfr = '0' + ddfr}
   if (mmfr < 10) {mmfr = '0' + mmfr}
   minDatefr = yyyyfr + '-' + mmfr + '-' + ddfr;
   //alert(minDatefr);
//mindate date range end
   //max date start
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0 so need to add 1 to make it 1!
    var yyyy = today.getFullYear();

    if (dd < 10) {dd = '0' + dd}
    if (mm < 10) {mm = '0' + mm}
    today = yyyy + '-' + mm + '-' + dd;     
    //max date end
function getMonday(d) 
    {
        d = new Date(d);      
        var day =d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
        return new Date(d.setDate(diff)).toLocaleDateString('en-CA');
    }


    //JSX Starts From Here
  return (
    <>
      
  <Modal isOpen={viewVehicle}>
  <div class="modal-header">
  <h5 className='modal-title'>View Details</h5>
  <button type="button" class="btn-close" onClick={closeVehicleModal}></button>
  </div>
  <div class="modal-body">
  <div className='row' >
  <div class="accordion" id="AVTFAQ">
  <div class="accordion-item">
  <h2 class="accordion-header" id="headingOne">
  <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faq-1" aria-expanded="true" aria-controls="collapseOne">
  Vehicle Details
  </button>
  </h2>
  <div id="faq-1" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#AVTFAQ">
  <div class="accordion-body">
  <p><div className='row' >
  <div class="col-sm-6 col-md-4 form-group">
  <b>Vehicle# : </b>{sVehicleNo} </div>
  <div class="col-sm-6 col-md-4 form-group">&nbsp;
  <b>Plate# : </b>{ sPlateNo}</div>
  <div class="col-sm-6 col-md-4 form-group">&nbsp;
  <b>Vehicle Type : </b>{sVehicleType} </div> 
  <div class="col-sm-6 col-md-4 form-group">&nbsp;
  <b>VIN : </b> {sVIN} </div>
  <div class="col-sm-6 col-md-4 form-group">&nbsp;
  <b>Make : </b> {sMake} </div>
  <div class="col-sm-6 col-md-4 form-group">&nbsp;
  <b>Vehicle Model : </b> {sModel} </div>
  <div class="col-sm-6 col-md-4 form-group">&nbsp;
  <b>Engine# : </b> {sEngineNo} </div>
  <div class="col-sm-6 col-md-4 form-group">&nbsp;
  <b>IMEI# : </b>{sIMEINo} </div>   
  <div class="col-sm-6 col-md-4 form-group">&nbsp;
  <b>FASTag# : </b>{sFASTag} </div>  
  <div class="col-sm-6 col-md-4 form-group">&nbsp;
  <b>Mileage (km/ltr) : </b> {sMileage} </div>
  </div> </p>
  </div>
  </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingTwo">
    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-2" aria-expanded="false" aria-controls="collapseTwo">    
    Registration Details 
    </button>
    </h2>
    <div id="faq-2" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#AVTFAQ">
    <div class="accordion-body">
    <p> <div className='row' ><div className='col-md-6 col-lg-4 form-group'>
    <b>Country : </b> {sCountry} </div>
    <div className='col-md-6 col-lg-4 form-group'>
    <b>State : </b> {sState} </div>
    <div className='col-md-6 col-lg-4 form-group'>
    <b>Year : </b> {sYear} </div>
    </div></p>
    </div></div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingThree">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-3" aria-expanded="false" aria-controls="collapseThree">
      Driver Details 
      </button>
    </h2>
    <div id="faq-3" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#AVTFAQ">
      <div class="accordion-body">
      <p><div className='row' > 
      <div className='col-md-6 col-lg-4 form-group'>
      <b>Name : </b>{sDriverName} </div>
      <div className='col-md-6 col-lg-4 form-group'>
      <b>Mobile : </b>{sContactNumber} </div> 
      <div className='col-md-6 col-lg-4 form-group'>
      <b>Address : </b>{sAddress} </div>
      </div>
      </p>
      </div>
    </div>
  </div> 
</div>          
             
                           
            </div>
             
            </div>
          
      </Modal>
      <Modal isOpen={showEditVehicle}>
            <div class="modal-header">
            <h5 className='modal-title'>Update Details</h5>
            <button type="button" class="btn-close" onClick={closeVehicleModal}></button>
            </div>
            <div class="modal-body">
            <div className='row'>
            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Vehicle Details </b> </span> 
            <div className='col-md-6 col-lg-4 form-group'>
            Vehicle# <span style={{color:"red"}}>&nbsp;*</span>
            <input name="vehicleNumber"  type="text" maxLength={12}  className="form-control"  value={inputsEdit.vehicleNumber || ""}  onChange={changeVEHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Plate# 
                            <input name="plateNumber"  type="text" maxLength={12}  className="form-control"  value={inputsEdit.plateNumber || ""}  onChange={changeVEHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Vehicle Type <span style={{color:"red"}}>&nbsp;*</span>
                            <select className="form-control" name="DVCategory" value={veCategoryID || ""}  onChange={ChangeVCategoryIDD}  >
                            <option value={0}>Select Vehicle Type</option>
                            {vCategoryData.map((e, key) => {
                            return <option key={key} value={e.vehicleID}>{e.vehicleType}</option>;
                            })}
                             </select> 
                            </div> 
                            <div className='col-md-6 col-lg-4 form-group'>
                            VIN 
                            <input name="vVin"  type="text"   className="form-control" value={inputsEdit.vVin || ""}  onChange={changeVEHandler}></input>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Make 
                            <input name="vBrand"  type="text"   className="form-control" value={inputsEdit.vBrand || ""}  onChange={changeVEHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Vehicle Model 
                            <input name="vModel"  type="text"   className="form-control"  value={inputsEdit.vModel || ""}  onChange={changeVEHandler}/>
                            </div>
                            
                            <div className='col-md-6 col-lg-4 form-group'>
                            Engine# 
                            <input name="vEnginNumber"  type="text"   className="form-control" value={inputsEdit.vEnginNumber || ""}  onChange={changeVEHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            IMEI#<span style={{color:"red"}}>&nbsp;*</span>  
                                   
                            <select className="form-control" name="IEMINumber" value={veIEMINumber || ""} onChange={ChangeIMEI}  disabled={true} >
                            <option value={0}>Select IMEI Number</option> 
                            veIEMINumber
                            <option value={veIEMINumber}>{veIEMINumber}</option>
                           {/* {vIEMIData.map((e, key) => 
                            {
                                return <option key={key} value={e.imeiNumber}>{e.imeiNumber}</option>;
                            })}*/}
                            </select>
                            </div>   
                            <div className='col-md-6 col-lg-4 form-group'>
                            FASTag# 
                            <input name="vFasTag"  type="text"   className="form-control" value={inputsEdit.vFasTag || ""}  onChange={changeVEHandler}/>
                            </div>     
                            <div className='col-md-6 col-lg-4 form-group'>
                            Mileage (km/ltr) 
                            <input name="vMileage"  type="text" maxLength={2}   className="form-control" value={inputsEdit.vMileage || ""}  onChange={changeVEHandler}></input>
                            </div>
                            
                            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Registration Details </b> </span> 
                           <div className='col-md-6 col-lg-4 form-group'>
                           Country <span style={{color:"red"}}>&nbsp;*</span>
                            <select className="form-control" name="DCountry" value={veCountryID || ""} onChange={ChangeCountryID}  >
                            <option value={0}>Select Country</option>
                            {vCountryData.map((e, key) => {
                            return <option key={key} value={e.id}>{e.country_Name}</option>;
                            })}
                            </select>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            State <span style={{color:"red"}}>&nbsp;*</span>
                            <select className="form-control slct" name="DState" value={veStateID || ""} onChange={ChangeStateID} >
                            <option value={0}>Select State</option>

                                {vStateData.map((e, key) => {
                                    return <option key={key} value={e.id}>{e.state_Name}</option>;
                                })}

                            </select>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group'>
                            Year 
                            <input name="vYear"  type="text" maxLength={4}  className="form-control" value={inputsEdit.vYear || ""}  onChange={changeVEHandler}></input>
                            </div>
                            <span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px"}}><b>Driver Details </b> </span> 
                            <div className='col-md-6 col-lg-4 form-group'>
                            Driver#                            
                            <select className="form-control" name="veDriverID" value={vEDriverID || ""} onChange={ChangeEDriver}  >
                            <option value={0}>Select Driver</option>
                            
                            {vDriverData.map((e, key) => {
                                return <option key={key} value={e.driverID}>{e.driverName}</option>;
                            })}
                            </select>
                            </div>
                            <div className='col-md-6 col-lg-4 form-group' style={{"paddingTop":"50px"}}>
                           </div>
                                
            </div>
            </div>
            <div class="modal-footer justify-content-center">
            <button className="btn btn-primary2" onClick={() => vehicleEdit()}>Update</button>            
             </div>  
      </Modal>
      <Modal isOpen={showLocation} >
            <div class="modal-header">
                <h5 className='modal-title'>Device Location Details</h5>
                <button type="button" class="btn-close" onClick={closeModal}></button>
                </div>
                <div class="modal-body">
            
            <div class="row">
            <Ctus id= {dID}/>
          
            </div> </div>
      </Modal>
      <ModalSale isOpen={showViewLiveVehicle}>
      <div class="modal-header">
      <h5 className='modal-title'>View Live</h5>
      <button type="button" class="btn-close" onClick={closeVehicleModal}></button>
      </div>
      <div class="modal-body">
      <div className='row'>
      <iframe width="1000px" height="800px" src={strLiveUrl}  title="" ></iframe>          
      </div>
      </div>
      </ModalSale>
      <ModalSale isOpen={showHistoryDetails} >
       
     <div class="modal-header">
                <h5 className='modal-title'>History Details</h5>
                <button type="button" class="btn-close" onClick={closeHistoryModal}></button>
     </div>
                <div class="modal-body" >                 
                <span style={{float: "left"}}>
                <button type="button" class="btn btn-primary2 mt-20" tabindex="1" id="btnTodayData" onClick={ShowTodayData} >Today</button>
                <button type="button" class="btn btn-primary2 mt-20" tabindex="2" id="btnWeeklyData" onClick={ShowWeeklyData} >Weekly</button>
                <button type="button" class="btn btn-primary2 mt-20" tabindex="3" id="btnMonthlyData" onClick={ShowMonthlyData} >Monthly</button>
                </span>
                <div class="row" >
                <div class="col-sm-1 col-md-1 form-group">From:</div>
                <div class="col-sm-4 col-md-4 form-group">
                <input type="date" className="form-control"  value={frFilterDate}  placeholder="dd-mm-yyyy" onChange={dfrChangeHandler}  min={minDatefr} max={today} />
                </div>
                <div class="col-sm-1 col-md-1 form-group" >To:</div>
                <div class="col-sm-4 col-md-4 form-group">
                <input type="date" className="form-control"  value={toFilterDate}  placeholder="dd-mm-yyyy" onChange={dtoChangeHandler}  min={minDatefr} max={today} />
                </div>
                <div class="col-sm-1 col-md-1 form-group">
                <button type="button" class="btn btn-primary2 mt-20" tabindex="4" id="btnSearch" onClick={ShowSearchData} >Search</button>
                </div>
                </div>
                <div><b> Vehicle No : {vehicleNo}</b></div>
                <br /> 
                <div hidden={isShowMap}>                
                <HistoryonMap Historyobj={historyonmapinfo} /> 
                 </div>       
                
                
                </div>
    </ModalSale>
    <ModalSale isOpen={showHistoryPlayback} >
       
     <div class="modal-header">
                <h5 className='modal-title'>History Playback Details</h5>
                <button type="button" class="btn-close" onClick={closeHistoryPlaybackModal}></button>
     </div>
                <div class="modal-body" >                 
                <span style={{float: "left"}}>
                <button type="button" class="btn btn-primary2 mt-20" tabindex="1" id="btnTodayData" onClick={ShowTodayData} >Today</button>
                <button type="button" class="btn btn-primary2 mt-20" tabindex="2" id="btnWeeklyData" onClick={ShowWeeklyData} >Weekly</button>
                <button type="button" class="btn btn-primary2 mt-20" tabindex="3" id="btnMonthlyData" onClick={ShowMonthlyData} >Monthly</button>
                </span>
                <div class="row" >
                <div class="col-sm-1 col-md-1 form-group">From:</div>
                <div class="col-sm-4 col-md-4 form-group">
                <input type="date" className="form-control"  value={frFilterDate}  placeholder="dd-mm-yyyy" onChange={dfrChangeHandler}  min={minDatefr} max={today} />
                </div>
                <div class="col-sm-1 col-md-1 form-group" >To:</div>
                <div class="col-sm-4 col-md-4 form-group">
                <input type="date" className="form-control"  value={toFilterDate}  placeholder="dd-mm-yyyy" onChange={dtoChangeHandler}  min={minDatefr} max={today} />
                </div>
                <div class="col-sm-1 col-md-1 form-group">
                <button type="button" class="btn btn-primary2 mt-20" tabindex="4" id="btnSearch" onClick={ShowSearchData} >Search</button>
                </div>
                </div>
                <div><b> Vehicle No : {vehicleNo}</b></div>
                <br /> 
                <div hidden={isShowMap}>                
                <HistoryPlayback Historyobj={historyonmapinfo} /> 
                 </div>       
                
                
                </div>
    </ModalSale>
      <div className="top-bar clearfix">
      <div className="row">
       
       <div className="col-md-4">
        <h2> Vehicles  </h2>           
        </div>
        <div className="col-md-8 text-right">
        
         <select onChange={exportStatus} className="btn btn-primary" name="Export"  value={statusId} >
         <option value={"0"}>All</option>    
         <option value={"1"}>Moving</option>  
         <option value={"2"}>Parked</option>   
         <option value={"3"}>No Network</option>                
         </select> 

        <select  onChange={exportDownload}  className="btn btn-primary" name="Download" >
        <option value={"Download"}>Download</option>    
        <option value={"Excel"}>Excel</option>    
        <option value={"PDF"}>PDF</option>  
        </select>
         </div>

       </div>

      </div>
     
 <div className="container-fluid p-3">
  <div class="card mb-3 shadow no-border border-0">
    <div class="card-body">
    <div class="row align-items-end">  
    <div class="col-sm-3 col-lg-2">Vehicle#<input type="text" class="form-control" tabindex="1" id="txtVehicleNumber" value={sVehicle} onChange={VchangeHandler} maxlength="50"/>
    </div>
    <div class="col-sm-3 col-lg-2">Vehicle Model<input type="text" class="form-control" tabindex="1" id="txtVehicleModel" value={ssmodel} onChange={MchangeHandler} maxlength="50"/>
    </div>
    <div class="col-sm-3 col-lg-2">Driver Name<input type="text" class="form-control" tabindex="1" id="txtDriverName" value={sdriver} onChange={DchangeHandler} maxlength="50"/>
    </div>       
    <div class="col-sm-4 col-lg-2">
    <button type="button" class="btn btn-primary2 mt-20" tabindex="6" id="btnAdvancedSearchNew" onClick={FilterGrid} >Search</button>
    <button type="button" class="btn btn-secondary mt-20" id="btnResetAdvancedSearchNew" tabindex="7" onClick={ResetList}>Reset </button></div>
    </div>    
    </div>
  </div>
  
      <div className="container-fluid p-3">
     
      <div class="card mb-3 shadow no-border border-0">
      <div class="card-body p-0">
          <table ref={tableRef} class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
            <thead>
              <tr>
                <th style={{textAlign:"center"}} width="5%">S.No.</th>
                <th width="10%" onClick={()=>sorting("vehicleNumber") } style={{textAlign:"center","cursor": "pointer"}}>Vehicle Number &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th> 
                <th width="10%" onClick={()=>sorting("imeiNumber") } style={{textAlign:"center","cursor": "pointer"}}>IMEI Number &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>                
                <th width="10%" onClick={()=>sorting("plateNumber") } style={{textAlign:"center","cursor": "pointer"}}>Plate Number &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>                               
                <th width="10%" onClick={()=>sorting("enginNumber") } style={{textAlign:"center","cursor": "pointer"}}>Engine Number &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
               
                <th width="5%" onClick={()=>sorting("vehicleBrand") } style={{textAlign:"center","cursor": "pointer"}}>Make &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%" onClick={()=>sorting("vehicleModel") } style={{textAlign:"center","cursor": "pointer"}}>Vehicle Model &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%" onClick={()=>sorting("vehicleType") } style={{textAlign:"center","cursor": "pointer"}}>Vehicle Type &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%" onClick={()=>sorting("driverName") } style={{textAlign:"center","cursor": "pointer"}}>Driver Name &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>  
                
                <th width="7%" onClick={()=>sorting("status") } style={{textAlign:"center","cursor": "pointer"}}>Status &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>  
                <th onClick={()=>sorting("vehicleID") } style={{textAlign:"center"}} width="13%">Action</th>            
              </tr>
            </thead>
            <tbody>
              {currentPost.map((Val) =>
               {
                return (
                  <>
              <tr key={Val.id}>
              <td style={{textAlign:"center"}}> {Val.id}</td>              
              <td>{Val.vehicleNumber}</td>
              <td>{Val.imeiNumber}</td>
              <td>{Val.plateNumber}</td>
              <td>{Val.enginNumber}</td>
              <td>{Val.vehicleBrand}</td>
              <td>{Val.vehicleModel}</td>
              <td> {Val.vehicleType}</td>
              <td>{Val.driverName}</td>   
              <td>{Val.status}</td> 
              <td style={{textAlign:"center", fontSize:"16px"}}>
              <span style={{textAlign:"left"}}>
              <i title="View Live" onClick={() => showLiveVehiclesModal(Val.imeiNumber)} style={{ fontSize:"14px", color:"#4edd4e", cursor:'pointer'}} className={(Val.acc===0 || Val.status==="Disabled") ?"display:none":"display:block fa-solid fa-wifi"}></i>   
              &nbsp;&nbsp;<i title="View History" onClick={() => showHistoryVehiclesModal(Val.imeiNumber, Val.vehicleNumber)}  style={{ fontSize:"14px", color:"#4edd4e", cursor:'pointer',color: "brown"}}  class='fas fa-history' ></i>           
              &nbsp;&nbsp;<i title="History Playback" onClick={() => showHistoryPlaybackModal(Val.imeiNumber, Val.vehicleNumber)}  className="fa-solid fa-play" style={{ fontSize:"14px", color:"#f53bee", cursor:'pointer'}}></i>
              &nbsp;&nbsp;<i onClick={() => showLocationDetailsModal(Val.deviceID)} style={{ color:"orange", cursor:'pointer'}} className={Val.status==="Disabled"?"display:none":"display:block fa-solid fa-location-dot"}  title="Monitor"></i>
              &nbsp;&nbsp;<i  onClick={() => shareLocationClick(Val.imeiNumber)} style={{ color:"rgb(13, 110, 253)", cursor:'pointer'}}  className={ Val.status==="Disabled" ?"display:none":"display:block fa-solid fa-share-nodes"}  title="Share Location"></i> 
              </span>
              <span style={{paddingLeft:"20px" }} >
              <i onClick={() => showDetailsModal(Val.vehicleID)} style={{ color:"green", cursor:'pointer'}} className={ Val.status==="Disabled" ?"display:none":"display:block fa-solid fa-list"} title="View Details"></i>
              &nbsp;&nbsp;<i  onClick={() => showEditVehicleDetails(Val.vehicleID)} style={{ color:"rgb(13, 110, 253)", cursor:'pointer'}}  className={ Val.status==="Disabled" ?"display:none":"display:block fa-solid fa-pen-to-square"}  title="Update Details"></i>              
              &nbsp;&nbsp;<i onClick={() => DeleteVehicleDetails(Val.vehicleID)} style={{ color:"red", cursor:'pointer'}} className={Val.status==="Disabled"?"display:none":"display:block  fa-solid fa-trash"}  title="Disable"></i>
              </span>
                {/*
                    &nbsp;&nbsp;<i  onClick={() => ActionCommandONOFF(Val.imeiNumber)}  style={{ color:"red",cursor:'pointer'}}  className={Val.status==="Disabled" || Val.iS_Relay===false?"display:none": (Val.commandStatus==="OFF") ?"fas fa-car":"fa fa-power-off"}  title="ON/OFF"></i>         
                */}
              </td>          
              </tr>
                  </>
                );
              })}
            </tbody>
          </table>
          <ReactPaginate  previousLabel={"<<"}  nextLabel={">>"}  pageCount={PageCount}  onPageChange={ChangePage} disableInitialCallback={true}  initialPage={0} containerClassName={'pagination justify-content-end'}   pageClassName={'page-item'}  pageLinkClassName={'page-link'}
          previousClassName={'page-item'}  previousLinkClassName={'page-link'}  nextClassName={'page-item'}  nextLinkClassName={'page-link'}  breakClassName={'page-item'}  breakLinkClassName={'page-link'}  activeClassName={'active'}></ReactPaginate>
        </div>
      </div></div></div>
      <ToastContainer position="bottom-right" autoClose={4000} theme="light"/> 
    </>
  );
};
export default AdminVehicleList;